<template>
  <span>
    <v-text-field
        id="m-time-field"
        class="rounded-lg"
        v-model="localValue"
        @input="change"
        dir="ltr"
        :label="label"
        :placeholder="placeholder"
        :disabled="disabled"
        append-icon="fa-clock"
        clearable
        style="min-width: 90px"
    >
      <template #append>
        <v-icon :disabled="disabled" class="mt-1" @click="$refs.timepicker.visible = true" @contextmenu.prevent="setToday"
        >fa-clock</v-icon
        >
      </template>
    </v-text-field>
    <vue-persian-datetime-picker
        v-model="localValue"
        type="time"
        @input="change"
        ref="timepicker"
        :element="id"
        :editable="true"
        format="HH:mm"
    />
  </span>
</template>

<script>
import Cleave from "cleave.js";
import moment from "moment-jalaali";
import IMask from "imask";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  name: "Time",
  props: ["value", "default", "disabled", "placeholder", "label"],
  components: { VuePersianDatetimePicker },
  data() {
    return {
      localValue: null,
      mask: null,
      isDirty: false,
      id: "time" + (Math.random() * 100000).toFixed(0),
    };
  },
  watch: {
    value() {
      this.localValue = this.value;
      if (this.localValue == undefined) {
        this.setToday();
      }
      this.change();
    },
  },
  created() {
    this.mask = IMask.createMask({
      mask: "HH:mm",
      blocks: {
        HH: {
          mask: IMask.MaskedRange,
          from: 0,
          to: 23,
        },
        mm: {
          mask: IMask.MaskedRange,
          from: 0,
          to: 59,
        },
      },
    });
  },
  mounted() {
    if (this.default) {
      this.setToday();
    } else {
      this.localValue = this.value;
    }
  },
  methods: {
    change() {
      this.isDirty = true;
      if (this.localValue != this.mask.value) {
        this.mask.resolve(String(this.localValue));
        this.$nextTick(() => {
          this.localValue = this.mask.value;
        });
        this.$emit("input", this.mask.value);
      }
    },
    setToday() {
      this.localValue = this.serverNow.format("HH:mm");
      this.change();
      this.$emit("input", this.mask.value);
    },
  },
};
</script>

<style lang="css" scoped>
input {
  direction: ltr;
}
</style>
